import { useMutation } from "@tanstack/react-query";

import { useApi } from "@/hooks";
import toast from "@/toast";
import { type ApiErrorResponse } from "@/types/api";

type ReportData = {
  account_id: string | null;
  status_ids: string[];
  message_ids: string[];
  group_id: string | null;
  rule_ids: string[];
  comment: string;
  forward: boolean;
  status_version?: string;
};

function useCreateReport() {
  const api = useApi();

  return useMutation({
    mutationFn: (data: ReportData) => api.post("/api/v1/reports", data),
    onError(error: ApiErrorResponse) {
      if (error.response?.data.error) {
        toast.error(error.response.data.error);
      }
    },
  });
}

export { useCreateReport };
